<template>
  <div :class="['sidebar', { 'sidebar-active': isOpen }]">
    <!-- En-tête de la sidebar -->
    <div class="sidebar-header">
      <div class="brand">
        <span class="brand-icon">🛒</span>
        <span class="brand-name">Supracare</span>
      </div>
      <button class="close-btn" @click="closeSidebar">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"/>
          <line x1="6" y1="6" x2="18" y2="18"/>
        </svg>
      </button>
    </div>

    <!-- Contenu du menu principal -->
    <div class="sidebar-content">
      <ul class="nav-list">
        <!-- Dropdown Produits -->
        <li class="nav-item">
          <DropdownComponent @navigateToProducts="navigateToProducts" @click="closeSidebar" />
        </li>
        
        <li class="nav-item" @click="closeNav">
          <a href="http://supracare.ma" target="_blank" class="nav-link">
            <span class="nav-icon">🏠</span>
            <span>Présentation</span>
          </a>
        </li>
        
        <li class="nav-item" @click="closeNav">
          <a href="http://supracare.ma/services" target="_blank" class="nav-link">
            <span class="nav-icon">🛡️</span>
            <span>Garantie</span>
          </a>
        </li>
        
        <li class="nav-item" @click="closeSidebar">
          <router-link to="/marques" class="nav-link">
            <span class="nav-icon">🏷️</span>
            <span>Marques</span>
          </router-link>
        </li>
        
        <li class="nav-item" @click="closeNav">
          <a href="http://supracare.ma/contact" target="_blank" class="nav-link">
            <span class="nav-icon">📞</span>
            <span>Contact</span>
          </a>
        </li>
      </ul>

      <hr class="divider" />

      <!-- Section Compte -->
      <div class="account-section">
        <!-- Si un utilisateur est connecté -->
        <div v-if="isLoggedIn">
          <!-- Client -->
          <div v-if="userRole === 'account'" class="user-dropdown">
            <button class="user-btn" @click="toggleDropdown">
              <div class="user-avatar">
                <span>{{ userInitials }}</span>
              </div>
              <div class="user-info-btn">
                <span class="user-name-btn">{{ userName }}</span>
                <span class="user-role-btn">Client</span>
              </div>
              <svg class="dropdown-arrow" :class="{ 'open': showDropdown }" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="6 9 12 15 18 9"/>
              </svg>
            </button>
            
            <transition name="dropdown">
              <ul v-if="showDropdown" class="dropdown-menu">
                <li><router-link to="/account" @click="closeSidebar">
                  <span class="menu-icon">👤</span> Mon compte
                </router-link></li>
                <li><router-link to="/wishlist" @click="closeSidebar">
                  <span class="menu-icon">❤️</span> Ma wishlist
                </router-link></li>
                <li><router-link to="/orderStatus" @click="closeSidebar">
                  <span class="menu-icon">📦</span> Mes commandes
                </router-link></li>
                <li class="logout-item"><a href="#" @click.prevent="logout">
                  <span class="menu-icon">🚪</span> Se déconnecter
                </a></li>
              </ul>
            </transition>
          </div>

          <!-- Admin -->
          <div v-else-if="userRole === 'admin'" class="user-dropdown">
            <button class="user-btn" @click="toggleDropdown">
              <div class="user-avatar admin-avatar">
                <span>{{ userInitials }}</span>
              </div>
              <div class="user-info-btn">
                <span class="user-name-btn">{{ userName }}</span>
                <span class="user-role-btn admin-role">Admin</span>
              </div>
              <svg class="dropdown-arrow" :class="{ 'open': showDropdown }" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="6 9 12 15 18 9"/>
              </svg>
            </button>
            
            <transition name="dropdown">
              <ul v-if="showDropdown" class="dropdown-menu">
                <li><router-link to="/dashboardAdmin" @click="closeSidebar">
                  <span class="menu-icon">📊</span> Tableau de bord
                </router-link></li>
                <li><router-link to="/adminOrders" @click="closeSidebar">
                  <span class="menu-icon">📦</span> Commandes
                </router-link></li>
                <li><router-link to="/products" @click="closeSidebar">
                  <span class="menu-icon">🧪</span> Produits
                </router-link></li>
                <li><router-link to="/clients" @click="closeSidebar">
                  <span class="menu-icon">👥</span> Clients
                </router-link></li>
                <li class="logout-item"><a href="#" @click.prevent="logout">
                  <span class="menu-icon">🚪</span> Se déconnecter
                </a></li>
              </ul>
            </transition>
          </div>
        </div>

        <!-- Si aucun utilisateur n'est connecté -->
        <router-link v-else to="/connexion" class="login-btn" @click="closeSidebar">
          <span class="login-icon">🔑</span>
          Connexion
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import DropdownComponent from "@/components/DropdownComponent.vue";

export default {
  name: "SidebarI",
  components: {
    DropdownComponent,
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isLoggedIn: false,
      userName: "",
      userInitials: "",
      dropdownOpen: false,
      userRole: "",
      showDropdown: false,
    };
  },
  mounted() {
    this.checkUserStatus();

    const storedUser = sessionStorage.getItem("user");
    if (storedUser) {
      const user = JSON.parse(storedUser);
      this.isLoggedIn = true;
      this.userName = `${user.prenom} ${user.nom}`;
      this.userRole = user.role;
      this.userInitials = this.userName.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2);
    }
  },
  methods: {
    toggleDropdown() {
      this.showDropdown = !this.showDropdown;
    },
    closeSidebar() {
      this.$emit("closeSidebar");
    },
    navigateToProducts() {
      this.$router.push("/DropdownComponent");
      this.closeSidebar();
    },
    closeNav() {
      this.closeSidebar();
    },
    goToLogin() {
      this.$router.push("/connexion");
      this.closeSidebar();
    },
    logout() {
      sessionStorage.removeItem('token');
      sessionStorage.removeItem('user');
      sessionStorage.removeItem('isAuthenticated');
      sessionStorage.removeItem('redirectAfterLogin');
      this.isLoggedIn = false;
      this.userName = "";
      this.userRole = "";
      this.userInitials = "";
      this.showDropdown = false;
      this.$router.push('/connexion');
      this.closeSidebar();
    },
    checkUserStatus() {
      const user = sessionStorage.getItem("user");
      if (user) {
        const parsedUser = JSON.parse(user);
        this.userName = `${parsedUser.prenom} ${parsedUser.nom}`;
        this.userInitials = this.userName.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2);
        this.isLoggedIn = true;
        this.userRole = parsedUser.role || "account";
      } else {
        this.isLoggedIn = false;
        this.userName = "";
        this.userInitials = "";
        this.userRole = "";
      }
    }
  },
  watch: {
    '$route'() {
      this.checkUserStatus();
    }
  }
};
</script>

<style scoped>

:root {
  --brand: #00998B;
  --brand-dark: #05305b;
  --ink: #1a1a2e;
  --gray: #6c7a89;
  --light-bg: #f7f9fc;
  --border: #edf2f7;
}

/* --- Base --- */
.sidebar {
  position: fixed;
  top: 0;
  left: 0;
  width: 300px;
  height: 100vh;
  background: #ffffff;
  color: var(--ink);
  border-right: 1px solid var(--border);
  box-shadow: 0 0 40px rgba(0, 0, 0, 0.05);
  transform: translateX(-100%);
  transition: transform 0.35s cubic-bezier(0.25, 1, 0.5, 1), box-shadow 0.3s ease;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.sidebar-active {
  transform: translateX(0);
  box-shadow: 0 0 60px rgba(0, 0, 0, 0.15);
}

/* --- En-tête --- */
.sidebar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 20px 16px;
  border-bottom: 1px solid var(--border);
  flex-shrink: 0;
}

.brand {
  display: flex;
  align-items: center;
  gap: 10px;
}

.brand-icon {
  font-size: 28px;
}

.brand-name {
  font-size: 20px;
  font-weight: 700;
  color: var(--brand-dark);
  letter-spacing: 0.5px;
}

.brand-name::after {
  content: '';
  display: inline-block;
  width: 4px;
  height: 4px;
  background: var(--brand);
  border-radius: 50%;
  margin-left: 4px;
  vertical-align: middle;
}

.close-btn {
  width: 36px;
  height: 36px;
  border: none;
  border-radius: 10px;
  background: var(--light-bg);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  color: var(--gray);
}

.close-btn:hover {
  background: #fee2e2;
  color: #e53935;
}

.close-btn svg {
  stroke: currentColor;
}

/* --- Contenu --- */
.sidebar-content {
  flex: 1;
  padding: 16px 16px 20px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}

/* --- Navigation --- */
.nav-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.nav-item {
  margin-bottom: 2px;
}

.nav-link {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 14px;
  border-radius: 10px;
  color: var(--ink);
  text-decoration: none;
  font-weight: 500;
  font-size: 14px;
  transition: all 0.2s ease;
  cursor: pointer;
}

.nav-link:hover {
  background: var(--light-bg);
  color: var(--brand);
}

.nav-link .nav-icon {
  font-size: 18px;
  width: 28px;
  text-align: center;
}

.router-link-active .nav-link {
  background: #e6f7f5;
  color: var(--brand);
}

/* --- Divider --- */
.divider {
  border: none;
  border-top: 1px solid var(--border);
  margin: 16px 0;
}

/* --- Compte --- */
.account-section {
  margin-top: auto;
}

/* --- User Button --- */
.user-btn {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 10px 14px;
  border: 1px solid var(--border);
  border-radius: 10px;
  background: var(--light-bg);
  cursor: pointer;
  transition: all 0.2s ease;
}

.user-btn:hover {
  background: #e6f7f5;
  border-color: var(--brand);
}

.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: linear-gradient(135deg, var(--brand), #007a6f);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 700;
  font-size: 14px;
  flex-shrink: 0;
}

.user-avatar.admin-avatar {
  background: linear-gradient(135deg, #6f42c1, #4a2a8a);
}

.user-info-btn {
  flex: 1;
  text-align: left;
}

.user-name-btn {
  display: block;
  font-weight: 600;
  font-size: 14px;
  color: var(--ink);
}

.user-role-btn {
  display: block;
  font-size: 11px;
  color: var(--gray);
}

.user-role-btn.admin-role {
  color: #6f42c1;
}

.dropdown-arrow {
  transition: transform 0.3s ease;
  stroke: var(--gray);
  flex-shrink: 0;
}

.dropdown-arrow.open {
  transform: rotate(180deg);
}

/* --- Dropdown Menu --- */
.dropdown-menu {
  list-style: none;
  padding: 8px;
  margin: 8px 0 0 0;
  background: var(--light-bg);
  border-radius: 10px;
  border: 1px solid var(--border);
}

.dropdown-menu li {
  margin-bottom: 2px;
}

.dropdown-menu li a {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
  border-radius: 8px;
  color: var(--ink);
  text-decoration: none;
  font-size: 13px;
  font-weight: 500;
  transition: all 0.2s ease;
}

.dropdown-menu li a:hover {
  background: #ffffff;
  color: var(--brand);
}

.menu-icon {
  font-size: 15px;
  width: 24px;
  text-align: center;
}

.dropdown-menu .logout-item a {
  color: #e53935;
}

.dropdown-menu .logout-item a:hover {
  background: #fee2e2;
  color: #c62828;
}

/* --- Dropdown Animation --- */
.dropdown-enter-active,
.dropdown-leave-active {
  transition: all 0.25s ease;
}

.dropdown-enter-from,
.dropdown-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

/* --- Login Button --- */
.login-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 12px 20px;
  background: #007a6f;
  color: white;
  border-radius: 10px;
  text-decoration: none;
  font-weight: 600;
  font-size: 14px;
  transition: all 0.3s ease;
}

.login-btn:hover {
  background: #007a2b;
  box-shadow: 0 4px 16px rgba(0, 153, 139, 0.3);
  transform: translateY(-2px);
}

.login-icon {
  font-size: 18px;
}

/* --- Mode sombre --- */
@media (prefers-color-scheme: dark) {
  .sidebar {
    background: #0f1720;
    border-right-color: #1a2532;
    color: #e6edf1;
  }

  .brand-name {
    color: #e6edf1;
  }

  .sidebar-header {
    border-bottom-color: #1a2532;
  }

  .close-btn {
    background: #1a2532;
    color: #8b97a3;
  }

  .close-btn:hover {
    background: #2a1a1a;
    color: #ef5350;
  }

  .nav-link {
    color: #8b97a3;
  }

  .nav-link:hover {
    background: #1a2532;
    color: #4ade80;
  }

  .router-link-active .nav-link {
    background: #1a3a38;
    color: #4ade80;
  }

  .divider {
    border-top-color: #1a2532;
  }

  .user-btn {
    background: #1a2532;
    border-color: #2a3645;
  }

  .user-btn:hover {
    background: #1a3a38;
    border-color: #4ade80;
  }

  .user-name-btn {
    color: #e6edf1;
  }

  .user-role-btn {
    color: #8b97a3;
  }

  .dropdown-arrow {
    stroke: #8b97a3;
  }

  .dropdown-menu {
    background: #1a2532;
    border-color: #2a3645;
  }

  .dropdown-menu li a {
    color: #8b97a3;
  }

  .dropdown-menu li a:hover {
    background: #0f1720;
    color: #4ade80;
  }

  .dropdown-menu .logout-item a {
    color: #ef5350;
  }

  .dropdown-menu .logout-item a:hover {
    background: #2a1a1a;
    color: #ff8a80;
  }

  .login-btn {
    background: #2a9d8f;
  }

  .login-btn:hover {
    background: #4ade80;
    color: #0f1720;
  }

  .user-avatar {
    background: linear-gradient(135deg, #2a9d8f, #1a6b62);
  }

  .user-avatar.admin-avatar {
    background: linear-gradient(135deg, #7b1fa2, #4a148c);
  }

  .user-role-btn.admin-role {
    color: #ab47bc;
  }
}

/* --- Responsive --- */
@media (max-width: 768px) {
  .sidebar {
    width: 280px;
  }

  .brand-name {
    font-size: 18px;
  }

  .nav-link {
    font-size: 13px;
    padding: 8px 12px;
  }

  .user-btn {
    padding: 8px 12px;
  }

  .user-avatar {
    width: 36px;
    height: 36px;
    font-size: 12px;
  }

  .user-name-btn {
    font-size: 13px;
  }

  .dropdown-menu li a {
    font-size: 12px;
    padding: 6px 10px;
  }

  .login-btn {
    font-size: 13px;
    padding: 10px 16px;
  }
}

@media (max-width: 480px) {
  .sidebar {
    width: 100%;
  }

  .sidebar-header {
    padding: 16px 16px 12px;
  }

  .brand-name {
    font-size: 16px;
  }

  .close-btn {
    width: 32px;
    height: 32px;
  }

  .close-btn svg {
    width: 20px;
    height: 20px;
  }

  .sidebar-content {
    padding: 12px;
  }

  .nav-link {
    font-size: 12px;
    padding: 6px 10px;
  }

  .nav-link .nav-icon {
    font-size: 16px;
    width: 24px;
  }

  .user-btn {
    padding: 6px 10px;
  }

  .user-avatar {
    width: 32px;
    height: 32px;
    font-size: 11px;
  }

  .user-name-btn {
    font-size: 12px;
  }

  .user-role-btn {
    font-size: 10px;
  }

  .dropdown-menu li a {
    font-size: 11px;
    padding: 5px 8px;
  }

  .menu-icon {
    font-size: 13px;
    width: 20px;
  }

  .login-btn {
    font-size: 12px;
    padding: 8px 14px;
  }

  .login-icon {
    font-size: 16px;
  }

  .divider {
    margin: 12px 0;
  }
}

/* Suppression sur desktop */
@media (min-width: 1040px) {
  .sidebar {
    display: none !important;
  }
}
</style>